import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { gql } from '@apollo/client'
import PubSub from 'pubsub-js'
import DatabaseSpinner from '../Spinner/Spinner.js'
import { Modal, Button, Table, Alert, Spinner } from 'reactstrap'
import { ACTION_TYPE, FIELD_TYPE } from '../../constants.js'
import RefListRow from './RefListRow.js'
import TotalsRow from './TotalsRow.js'
import AppObject from '../AppObject/AppObject'
import { getChangeCount, publishEvent, hasActionType, createInitialFormInput, getActionOfType, isDisabled, makeInteger, deepCopy } from '../../utils'
import { NEW_OBJECT_QUERY, GET_REF_LIST_DATA_QUERY } from '../../graphql'
import { validateInput } from '../../validate'
import './ReferenceList.css'

export const NEW_OBJECT = gql(NEW_OBJECT_QUERY)
export const GET_REF_LIST_DATA = gql(GET_REF_LIST_DATA_QUERY)

export default function ReferenceList(props) {
  const { formInputs, field, object, action } = props
  console.log(`ReferenceList "${field.name}" rendered`, props)

  const objectId = object.id
  const [changeCount, setChangeCount] = useState(0)
  const [error, setError] = useState('')
  const [child, setChild] = useState({ modal: false, childAppObject: '' })
  const [adding, setAdding] = useState(false)
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const [dataSpinner, setDataSpinner] = useState(false)
  const toggle = () => setChild({ modal: !child.modal })
  const disabled = isDisabled(action, field.behaviorType)
  const location = useLocation()
  const printView = location.pathname.includes('printView') ? true : false
  let errorComponent = null
  let childAppObject = null
  
  function modifyChangeCount(delta) {
    console.log(`ReferenceList.modifyChangeCount delta: ${delta} changeCount: ${changeCount}`)
    let notifyParent = false
    if (changeCount === 1 && delta === -1) {
      formInputs.changed = false
      notifyParent = true
    }
    if (changeCount === 0 && delta === 1) {
      formInputs.changed = true
      notifyParent = true
    }
    setChangeCount(changeCount + delta)
    if (notifyParent) {
      publishEvent(`CHANGE COUNT ${objectId}`, delta, 'ReferenceList.modifyChangeCount')
    }
  }

  function gridDataRowFromChild(child) {
    const newGridRow = []
    newGridRow.push(child.object.id)
    for (let detail of formInputs.currentValue.details) {
      let gridColumnValue = null
      let currentValue = child.formInputs[detail.field.id].currentValue
      console.log('ReferenceList.girdDataRowFromChild: ', { child, currentValue })
      if (currentValue || currentValue ===  0) {
        switch (detail.field.type.id) {
          case FIELD_TYPE.select:
            gridColumnValue = currentValue.name
            break
          case FIELD_TYPE.yesNo:
            gridColumnValue = currentValue === 'Y' ? 'Yes' : 'No'
            break
          default:
            gridColumnValue = currentValue
        }
      }
      newGridRow.push(gridColumnValue)
    }
    console.log('ReferenceList.girdDataRowFromChild: ', { newGridRow })
    return newGridRow
  }

  async function saveChanges() {
    console.log('ReferenceList.saveChanges', { child, formInputs })
    const validationErrors = []
    await validateInput(child.formInputs, validationErrors, child.object)
    console.log('validationErrors: ', validationErrors)
    if (validationErrors.length === 0) {
      formInputs.currentValue[child.object.id] = child.formInputs
      setChild({ modal: !child.modal, childAppObject: '' })
      if (child.buttonClicked === 'ADD') {
        // SUBMIT
        formInputs.currentValue.gridData.push(gridDataRowFromChild(child))
        formInputs.currentValue.objects.push(child.object)
        // pop the submit ref list form input from the global list
        window.refListSubmitInputs.pop()
        //handleChange(formInputs.currentValue, hasChanged, field.id)
        modifyChangeCount(1)
      } else {
        // MODIFY - only if the child object is not being submitted
        if (!child.object.submitting) {
          const newChildChangeCount = getChangeCount(child.formInputs)
          const oldChildChangeCount = child.changeCount
          console.log(`ReferenceList.saveChanges oldChildChangeCount: ${oldChildChangeCount} newChildChangeCount: ${newChildChangeCount}`)
          let refListDelta = 0
          if (newChildChangeCount === 0 && oldChildChangeCount > 0) {
            refListDelta = -1
          } else if (newChildChangeCount > 0 && oldChildChangeCount === 0) {
            refListDelta = 1
          }
          console.log(`ReferenceList.saveChanges refListDelta: ${refListDelta}`)
          if (refListDelta !== 0) {
            modifyChangeCount(refListDelta)
          }
        } else {
          // change the child object action from MODIFY to SUBMIT for final saving
          const submitAction = getActionOfType(formInputs.currentValue.actions, ACTION_TYPE.submit)
          formInputs.currentValue[child.object.id].action = submitAction
         
        }
      }
    } else {
      // Notify the AppObject to display the errors
      publishEvent(`SET ERRORS ${child.object.id}`, validationErrors, 'ReferenceList.saveChanges')
    }
  }

  function cancelChanges() {
    console.log('ReferenceList.cancelChanges')
    window.refListSubmitInputs.pop()
    setChild({ modal: !child.modal })
  }

  useEffect(() => {
    // function handleChangeCountEvent(msg, data) {
    //   console.log(`EVENT RECEIVED (ReferenceList ${field.name}): ${msg}`, data)
    //   modifyChangeCount(data)
    // }
    function handleOkButtonEvent(msg, data) {
      console.log(`EVENT RECEIVED (ReferenceList ${field.name}): ${msg}`, data)
      saveChanges()
    }
    function handleCancelButtonEvent(msg, data) {
      console.log(`EVENT RECEIVED (ReferenceList ${field.name}): ${msg}`, data)
      cancelChanges()
    }
    function handleDeleteRowEvent(msg, data) {
      console.log(`DELETE EVENT RECEIVED (ReferenceRow): ${msg}`)
      console.log('what referencelist has', formInputs)
      let actions = formInputs.currentValue.actions
      let details = formInputs.currentValue.details
      delete formInputs.currentValue
      formInputs.currentValue = {
        actions: actions,
        details: details,
        gridData: [],
        objects: []
      }
      formInputs.previousValue = {}
      formInputs.savedValue = {}
      setChangeCount(1)
      modifyChangeCount(1)
    }

    const tokens = []
    // if (formInputs.currentValue.gridData) {
    //   for (let refListRowData of formInputs.currentValue.gridData) {
    //     tokens.push(PubSub.subscribe(`CHANGE COUNT ${refListRowData[0]}`, handleChangeCountEvent))
    //   }
    // }
    const okButtonToken = PubSub.subscribe(`CHILD OK BUTTON ${field.id}`, handleOkButtonEvent)
    const cancelChangesToken = PubSub.subscribe(`CANCEL CHILD CHANGES ${field.id}`, handleCancelButtonEvent)
    const deleteRowTokenFromQueryDetail = PubSub.subscribe('QUERY DETAILS DOCUMENT TYPE CHANGES', handleDeleteRowEvent)
    return function cleanup() {
      for (let token of tokens) {
        PubSub.unsubscribe(token)
      }
      PubSub.unsubscribe(okButtonToken)
      PubSub.unsubscribe(cancelChangesToken)
      PubSub.unsubscribe(deleteRowTokenFromQueryDetail)
    }
  })

  useEffect(() => {
    async function fetchRefListData() {
      setDataSpinner(true)
      const { data, errors } = await window.apolloClient.query({ query: GET_REF_LIST_DATA, variables: { objectId: objectId, fieldId: field.id } })
      if (data.getRefListData) {
        console.log(data.getRefListData)
        formInputs.savedValue = data.getRefListData
        formInputs.currentValue = deepCopy(data.getRefListData)
      }
      setDataSpinner(false)
      if (errors) {
        console.log('ReferenceList.useEffect errors', errors)
        setGraphQLErrors(errors)
      }
    }
    if (!formInputs.currentValue.gridData) {
      console.log(`${field.name} ReferenceList data load: `, JSON.parse(JSON.stringify(formInputs)))
      fetchRefListData()
    }
  }, [field, formInputs, objectId])

  function setIncrements(formData) {
    const newFormData = deepCopy(formData)
    console.log('ReferenceList.setIncrements: ', {newFormData, formInputs})
    for (let fieldId in formData) {
      const field = formData[fieldId].field
      if (field && field.incrementBy) {
        console.warn(`ReferenceList.setIncrements incrementing ${field.name}`)
        let newValue = makeInteger(formData[fieldId].currentValue)

        // get the column index of the field to be incremented
        const details = formInputs.currentValue.details
        const gridData = formInputs.currentValue.gridData
        let index
        for (index = 0; index < details.length; index++) {
          if (makeInteger(details[index].field.id) === makeInteger(field.id)) {
            console.warn(`ReferenceList.setIncrements index value: ${index}`)
            break
          }
        }
        if (gridData.length > 0) {
          // Use index + 1 of last row because the object ID is always the first column in gridData
          const lastValue = makeInteger(gridData[gridData.length - 1][index + 1])
          newValue = lastValue + makeInteger(formData[fieldId].field.incrementBy)
          newFormData[fieldId].currentValue = newValue
          console.warn(`ReferenceList.setIncrements newValue: ${newValue}`)
        }

        // if (formInputs.currentValue.objects.length > 0) {
        //   // get the last object added to the reference list
        //   const lastObject = formInputs.currentValue.objects[formInputs.currentValue.objects.length - 1]
        //   // get the field value from the last object and convert to integer
        //   const lastValue = makeInteger(formInputs.currentValue[lastObject.id][fieldId].currentValue)
        //   // if the conversion worked, convert the incrementBy value and add it to lastValue
        //   if (lastValue) {
        //     newValue = lastValue + makeInteger(formData[fieldId].field.incrementBy)
        //   }
        // }
      }
    }
    return newFormData
  }

  async function addButtonClicked() {
    console.log('ReferenceList.addButtonClicked', field)
    // turn on the spinner
    setAdding(true)
    try {
      const results = await window.apolloClient.query({
        query: NEW_OBJECT,
        variables: { objectTypeId: field.referenceTo.id, parentObjectId: objectId }
      })
      // turn off the spinner
      setAdding(false)
      const newObject = results.data.newObject
      const submitAction = getActionOfType(formInputs.currentValue.actions, ACTION_TYPE.submit)
      const initialFormData = createInitialFormInput(newObject, submitAction)
      const formData = setIncrements(initialFormData)
      newObject.submitting = true
      childAppObject = <AppObject object={newObject} action={submitAction} parentObjectId={objectId} refListId={field.id} existingFormInput={formData} />
      // add a global reference to the submitted ref list formInputs for validation access by child ref list items
      window.refListSubmitInputs.push(formData)
      console.log('ReferenceList.addButtonClicked: window.refListSubmitInputs: ', window.refListSubmitInputs)
      setChild({
        modal: true,
        childAppObject: childAppObject,
        formInputs: formData,
        object: newObject,
        buttonClicked: 'ADD'
      })
    } catch (e) {
      console.log(e)
      setAdding(false)
      setError(e)
    }
  }

  function editButtonClicked(refListObject) {
    console.log('ReferenceList.editButtonClicked', refListObject, window)

    // determine which action to assign (submit or modify)
    // if the parent is being submitted, then all child objects should be submitted as well
    let childAction
    if (makeInteger(window.rootFormInputs.action.type.id) === ACTION_TYPE.submit) {
      childAction = getActionOfType(refListObject.type.actions, ACTION_TYPE.submit)
    } else {
      childAction = getActionOfType(refListObject.type.actions, ACTION_TYPE.modify)
    }
    
    // copy the current values for editing
    const formData = deepCopy(formInputs.currentValue[refListObject.id])
    formData.action = childAction
    const childChangeCount = getChangeCount(formData)
    console.log(`childChangeCount: ${childChangeCount}`)
    childAppObject = <AppObject object={refListObject} action={childAction} parentObjectId={objectId} refListId={field.id} existingFormInput={formData} />
    setChild({
      modal: true,
      childAppObject: childAppObject,
      formInputs: formData,
      object: refListObject,
      buttonClicked: 'EDIT',
      changeCount: childChangeCount
    })
  }

  function removeRow(objectId) {
    console.log('ReerenceList.removeRow: ', objectId, formInputs)
    delete formInputs.currentValue[objectId]

    // delete it from the objects array
    for (let i = 0; i < formInputs.currentValue.objects.length; i++) {
      if (makeInteger(formInputs.currentValue.objects[i].id) === makeInteger(objectId)) {
        console.log('removeRow: object list before splice: ', formInputs.currentValue.objects)
        formInputs.currentValue.objects.splice(i, 1)
        console.log('removeRow: object list after splice: ', formInputs.currentValue.objects)
        break
      }
    }

    // delete it from the gridData array
    for (let i = 0; i < formInputs.currentValue.gridData.length; i++) {
      if (makeInteger(formInputs.currentValue.gridData[i][0]) === makeInteger(objectId)) {
        console.log('removeRow: object list before splice: ', formInputs.currentValue.gridData)
        formInputs.currentValue.gridData.splice(i, 1)
        console.log('removeRow: object list after splice: ', formInputs.currentValue.gridData)
        break
      }
    }
    modifyChangeCount(-1)
  }

  // ref list components
  const headings = []
  const rows = []

  if (formInputs.currentValue.actions) {
    //decide if add button is needed
    if (adding) {
      headings.push(<th key={0}><Spinner size="sm" color="primary" /></th>)
    } else {
      if (!disabled && action && hasActionType(formInputs.currentValue.actions, ACTION_TYPE.submit)) {
        console.log('currentValue', field.name)
        headings.push(<th key={0} className="ref-list-add-button-cell"><Button className="ref-list-add-button" color="success" size="sm" onClick={addButtonClicked} data-cy={`ref-list-add-button-${field.name.toLowerCase().replace(/ /g, '-')}`} >Add</Button></th>)
      } else {
        if (!printView) {
          headings.push(<th key={0}></th>)
        }
      }
    }

    // build ref list grid headings
    if (formInputs.currentValue.details) {
      for (let column of formInputs.currentValue.details) {
        headings.push(<th key={column.field.id}>{column.field.name}</th>)
      }
    }

    // for each row in the ref list 
    if (formInputs.currentValue.gridData) {
      for (let gridRow of formInputs.currentValue.gridData) {
        // if the RefList is read-only then set the parentAction to null
        let parentAction = action
        if (disabled) {
          parentAction = null
        }
        rows.push(<RefListRow
          key={gridRow[0]}
          details={formInputs.currentValue.details}
          gridRow={gridRow}
          formInputs={formInputs.currentValue}
          editButtonClicked={editButtonClicked}
          removeRow={removeRow}
          parentObjectId={objectId}
          parentAction={parentAction}
          userActions={formInputs.currentValue.actions}
          colSpan={formInputs.currentValue.details.length}
          modifyRefListChangeCount={modifyChangeCount}
          fileJwt={object.fileJwt}
          printView={printView}
        />)
      }
    }
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (dataSpinner) {
    return <DatabaseSpinner />
  } else {
    if (error) {
      errorComponent = <Alert color="danger">{error.message}</Alert>
    }
    return (
      <div className="ref-list-container" data-cy='ref-list-container'>
        {errorComponent}
        <Modal isOpen={child.modal} toggle={toggle} className="ref-list-modal" contentClassName="ref-list-modal-content" backdrop="static">
          {child.childAppObject}
        </Modal>
        <div className="ref-list-table-container">
          <Table hover className="ref-list-table" bordered size="sm">
            <thead className="ref-list-table-head">
              <tr className="ref-list-table-head-row">
                {headings}
              </tr>
            </thead>
            <tbody className="ref-list-table-body">
              {rows}
              <TotalsRow formInputs={formInputs} printView={printView}/>
            </tbody>
          </Table>
        </div>
      </div>
    )
  }
}